module.exports = __webpack_public_path__ + "static/media/vnda12.b109c459.png";